import { getZombieInstanceFromPrimaryKey } from '@iotv/datamodel-core';
import qs from 'qs';
import { loadable } from 'react-lazily/loadable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TransactionFunctions, UserFunctions } from '../redux/actions/AppActionFunctions/AppActions';
const ListView = loadable(() => import('../components/ThingsView/ListView')).default;
const debug = process.env.REACT_APP_DEBUG && false;
const mapStateToProps = (state, ownProps) => {
    debug && console.log('ListView own props', ownProps);
    const { location } = ownProps;
    const applicationData = state.AppReducer.applicationData;
    const { contextObjectSk } = qs.parse(location.search, { ignoreQueryPrefix: true });
    const contextObject = applicationData.getItem(getZombieInstanceFromPrimaryKey(contextObjectSk ?? 'never'));
    return {
        userGroupRoles: state.AppReducer.userGroupRoles,
        contextObjectSk,
        contextObject: contextObject,
        contextCustomer: state.AppReducer.contextCustomer,
    };
};
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        init: (cognitoUser, userGroupRoles) => {
            debug && console.log('ListView Container requested init', ownProps);
        },
        userFunctions: bindActionCreators(UserFunctions, dispatch),
        transactionFunctions: bindActionCreators(TransactionFunctions, dispatch),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(ListView);
